module.exports = __webpack_public_path__ + "img/comic.4e4e71f0.jpeg";